module.exports = __webpack_public_path__ + "static/media/stripTease.c38e66f0.svg";